/* GENERATED by src/store_configurator.py from src/site/configurator/<step>.js - do not edit here. */
/* camera.js */
// Camera step: any camera, or "I already have a camera" (mount + sensor format + interface typed in).
(function () {
  var IFACES = ["GigE", "2.5GigE", "5GigE", "10GigE", "USB3", "CoaXPress", "Camera Link"];
  var T = LSConfig.t;  // customer text by key "camera.<name>" + the English with {placeholders} (core.js; the theme translates)
  LSConfig.step("camera", {
    filters: ["Interface", "Resolution", "Sensor format", "Colour", "Shutter", "Lens mount", "Availability"],
    chips: ["Resolution", "Sensor format", "Interface", "Shutter", "Colour"],
    skip: T("camera.skip", "I'll choose the camera later"),
    fit: function (r, sys) {
      var l = sys.lens, x = r.x || {};
      if (!l) return [2, ""];
      var checked = function (status, text) {
        return status === 2 && l.projection === "fisheye" ? [1, T("lens.fisheye_check", "Fisheye lens: confirm image coverage, field of view and focus for your setup.")] : [status, text];
      };
      // QA22c: a SWIR / UV / thermal lens only on a camera made for that band, and back (lens and camera rows' wl)
      if (l.wl && x.wl !== l.wl) return [0, T("camera.needs_band", "needs a {band} camera", { band: l.wl })];
      if (x.wl && !l.wl) return [0, T("camera.band_lens", "{band} camera: needs a {band} lens", { band: x.wl })];
      // the lens must cover the sensor (same 0.97 tolerance as the lens step; line cameras: the line length)
      var need = x.kind === "line" ? x.line_mm : x.mm;
      if (l.projection !== "fisheye" && l.mm && need && l.mm < need * 0.97) return [0, T("camera.circle_small", "Image circle {ic} mm, sensor {sensor} mm", { ic: l.mm, sensor: need })];
      if (!l.mount) return checked(2, "");
      if (!x.mount) return [1, T("camera.mount_unstated", "camera mount not stated")];
      if (l.mount === x.mount) return checked(2, T("camera.fits_lens", "Fits your {mount} lens", { mount: l.mount }));
      if (l.mount === "C-mount" && x.mount === "CS-mount") return checked(2, T("camera.fits_ring", "Fits your lens with a 5 mm C-CS ring"));
      // the lens step's own mount rule (rings it stocks: M42 / M58 / M72 to C or F ...), so lens-first and camera-first agree
      var via = LSConfig.lensAdapter ? LSConfig.lensAdapter(l.mount, x.mount) : null;
      if (via) return l.projection === "fisheye" ? checked(2, "") : via.closeUp ? [1, T("camera.close_up", "only close-up with {adapter}", { adapter: via.m })] : checked(2, T("camera.fits_with", "Fits your {mount} lens with {adapter}", { mount: l.mount, adapter: via.m }));
      return [0, T("camera.mount_differs", "{camera} camera, {lens} lens", { camera: x.mount, lens: l.mount })];
    },
    note: function (sys) {
      return sys.lens && sys.lens.mount ? T("camera.note_lens", "Showing cameras that take your {mount} lens.", { mount: sys.lens.mount }) :
        T("camera.note_sale", "Parts marked Add to quote or Price on request go on a quote request; the rest can go straight into the cart.");
    },
    apply: function (r, p, sys) {
      var x = r.x || {};
      Object.keys(x).forEach(function (k) { sys[k] = x[k]; });
      sys.camera = r.m;
    },
    top: function (el, api) {
      var F = LSConfig.FORMAT_MM, fmts = Object.keys(F).sort(function (a, b) { return F[a] - F[b]; });
      var h = api.sys.camera ? null : (new URLSearchParams(location.search).get("have") ? api.sys : null);
      var opt = function (l, cur) { return '<option value="">-</option>' + l.map(function (v) { return '<option' + (v === cur ? " selected" : "") + ">" + api.esc(v) + "</option>"; }).join(""); };
      el.innerHTML = '<details class="cfghave"' + (h ? " open" : "") + '><summary>' + api.esc(T("camera.have", "I already have a camera")) + '</summary><div class="filters">' +
        '<label class="fsel">' + api.esc(T("camera.lens_mount", "Lens mount")) + '<select name="mount">' + opt(LSConfig.MOUNTS, h && h.mount) + "</select></label>" +
        '<label class="fsel">' + api.esc(T("camera.sensor_format", "Sensor format")) + '<select name="fmt">' + opt(fmts, h && h.fmt) + "</select></label>" +
        '<label class="fsel">' + api.esc(T("camera.interface", "Interface")) + '<select name="iface">' + opt(IFACES, h && h.iface) + "</select></label>" +
        '<label class="fsel">' + api.esc(T("camera.type", "Type")) + '<select name="kind"><option value="area">' + api.esc(T("camera.area_scan", "Area scan")) + '</option><option value="line"' + (h && h.kind === "line" ? " selected" : "") + ">" + api.esc(T("camera.line_scan", "Line scan")) + "</option></select></label>" +
        '<button type="button" class="btn">' + api.esc(T("camera.use_mine", "Use my camera")) + '</button></div><p class="muted small">' + api.esc(T("camera.use_mine_note", "We then show the lenses, cables and accessories that fit it.")) + "</p></details>";
      el.querySelector("button").onclick = function () {
        var v = {};
        Array.prototype.forEach.call(el.querySelectorAll("select"), function (s) { if (s.value) v[s.name] = s.value; });
        if (!v.mount && !v.fmt) { window.LSConfig && window.LSConfig.toast(T("camera.pick_one", "Pick at least the lens mount or the sensor format.")); return; }
        if (v.fmt) v.mm = F[v.fmt];
        api.picks().forEach(function (p) { api.unpick(p.h); });
        api.have(v);
        api.next();
      };
    }
  });
})();

/* lens.js */
// Lens step (owner 2026-10-15: "select the exact lens type and configuration ... make the configuration impressive").
// The visitor's sensor + working distance + field of view give the focal length (fixed-focal, zoom, M12, CCTV, IR)
// or the magnification (telecentric, macro, line scan, 360) the scene needs; a live diagram shows the set-up, and each
// lens shows the field of view it gives there. Fit checks the mount (adapters are added automatically: C-CS ring,
// C->F, M12->CS, CS->M12, M42/M58/M72 rings), the image circle against the sensor, the lens's resolving power against
// the camera pixels, the focal length / magnification, and the close-focus limit (an extension ring is added when the
// part is nearer than the lens focuses). A shorter focal length (up to 30%) fits and "sees a bit more"; a longer one
// shows less than asked, so beyond 4% it is a check that says how far to move back. 360° lenses are chosen by the
// part's diameter, not by the scene. Audit: replaying fit() for every camera x scene, a "Fits" lens must pass the mount,
// image circle and FOV/magnification checks again (2026-10-17: 0 errors in ~90k). Rows: lens.py. Keeps sys.scene {wd_mm, fov_w_mm, fov_h_mm, feat_mm} and
// sys.lens {mount, mm, ring} (light, camera and extras steps read them).
(function () {
  var T = LSConfig.t;  // customer text by key "lens.<name>" + the English with {placeholders} (core.js; the theme translates)
  var KINDS = [["fa", T("lens.k_fa", "Fixed focal length")], ["tele", T("lens.k_tele", "Telecentric")], ["macro", T("lens.k_macro", "Macro & close-up")],
    ["zoom", T("lens.k_zoom", "Zoom & varifocal")], ["line", T("lens.k_line", "Line scan")], ["s360", T("lens.k_s360", "360° inspection")],
    ["m12", T("lens.k_m12", "M12 board lenses")], ["ir", T("lens.k_ir", "SWIR, thermal & UV")], ["cctv", T("lens.k_cctv", "CCTV & fisheye")]];
  var MAG = { tele: 1, macro: 1, line: 1, s360: 1 };
  // rank offsets: a plain fixed-focal lens leads unless it is far off; specialist optics (telecentric, macro, 360)
  // come first only when the visitor picks that type or nothing ordinary fits (they cost far more)
  var PREF = { fa: 0, m12: 0.05, cctv: 0.2, zoom: 0.3, ir: 0.9, macro: 0.3, tele: 0.45, line: 0, s360: 0.6 };
  var EXAMPLES = [  // quick starts: [label, wd, fov width, smallest feature]
    [T("lens.ex_label", "Read a label or barcode"), 400, 150, 0.5], [T("lens.ex_pcb", "Inspect a PCB"), 200, 80, 0.1],
    [T("lens.ex_gauge", "Gauge a small part"), 110, 12, 0.01], [T("lens.ex_cap", "Check a bottle cap"), 300, 60, 0.2]];
  var CAMSIDE = { C: "C-mount", CS: "CS-mount", F: "F-mount" };
  var MOUNT_OPTS = ["C-mount", "CS-mount", "M12", "F-mount", "M42", "M58", "M72", "M90", "M95", "V-mount", "EF-mount"];  // = core MOUNTS
  var r1 = function (v) { return v >= 100 ? Math.round(v) : v >= 10 ? Math.round(v * 10) / 10 : Math.round(v * 100) / 100; };
  var range = function (a, u) { return a[0] === a[1] || a[1] == null ? r1(a[0]) + (a[1] == null ? "+" : "") + u : r1(a[0]) + "-" + r1(a[1]) + u; };
  var ADD = [], LOADED = false;  // the add-on rows (adapters, rings, filters), from load(); LOADED once the rows are in

  function sensor(sys) {  // [width, height] mm of the camera sensor: measured, else 4:3 of the format diagonal
    if (sys.kind === "line" && sys.line_mm) return [sys.line_mm, 0];
    if (sys.w) return [sys.w, sys.hh || 0];
    if (sys.mm) return [sys.mm * 0.8, sys.mm * 0.6];
    return null;
  }
  function need(sys) {  // what the scene asks for: {m magnification, f focal length mm, wd, s sensor}
    var sc = sys.scene, s = sensor(sys);
    if (!sc || !sc.wd_mm || !sc.fov_w_mm || !s) return null;
    var m = s[0] / sc.fov_w_mm;
    if (sc.fov_h_mm && s[1]) m = Math.min(m, s[1] / sc.fov_h_mm);  // both sides must fit in the image
    return { m: m, f: sc.wd_mm * m / (1 + m), wd: sc.wd_mm, s: s };
  }
  function lensPx(x) {  // pixel pitch (um) the lens resolves: stated, else its MP rating spread over its image circle
    if (x.px) return x.px;
    if (x.mp && x.ic) return Math.sqrt(0.48 * x.ic * x.ic / (x.mp * 1e6)) * 1000;
    return null;
  }

  // ---- mount: native, or through one adapter we sell ----------------------------------------------------------
  function adapterFor(lensMt, camMt) {  // add-on row that puts a lens with mount lensMt on a camera with mount camMt
    var role = lensMt === "C-mount" && camMt === "CS-mount" ? "ccs" : lensMt === "C-mount" && camMt === "F-mount" ? "cf"
      : lensMt === "M12" && camMt === "CS-mount" ? "m12cs" : (lensMt === "CS-mount" || lensMt === "C-mount") && camMt === "M12" ? "csm12" : null;
    return ADD.filter(function (a) {
      var x = a.x;
      if (role) return x.acc === role && (role !== "ccs" || x.len === 5);
      return x.acc === "ring" && x.from === camMt && CAMSIDE[x.to] === lensMt;
    })[0] || null;
  }
  function mountFit(x, sys) {  // {mt: lens mount used, a: adapter row or null}; null = no way to fit
    var mt = x.mt || [];
    if (!sys.mount) return { mt: mt[0], a: null };
    if (mt.indexOf(sys.mount) >= 0) return { mt: sys.mount, a: null };
    for (var i = 0; i < mt.length; i++) { var a = adapterFor(mt[i], sys.mount); if (a) return { mt: mt[i], a: a }; }
    return null;
  }
  // For the camera step (lens picked first): the stocked route from a lens mount to a camera mount, or null.
  // {m: adapter model(s), closeUp: true for the C-F adapter (a 29 mm extension)}. Needs the lens rows loaded (they
  // are, once a lens is picked).
  LSConfig.lensAdapter = function (lensMt, camMt) {
    var a = adapterFor(lensMt, camMt);
    if (!a) return null;
    var models = [a.m];
    if (a.x.acc === "csm12" && lensMt === "C-mount") {
      var ring = ADD.filter(function (r) { return r.x.acc === "ccs" && r.x.len === 5; })[0];
      if (ring) models.push(ring.m);
    }
    return { m: models.join(" + "), closeUp: a.x.acc === "cf" };
  };
  // C lens on an F-mount camera: the C-F adapter puts the lens 46.5 - 17.526 = 28.97 mm behind its flange (an extension
  // tube): close-up only. Focus range from that extension e: m = e/f (lens at infinity) to e/f + m at the lens's MOD.
  var CF_EXT = 28.97;
  function cfRange(x) {  // [near, far] object distance (mm) a fixed-focal C lens focuses at on the C-F adapter, or null
    if (x.projection === "fisheye") return null;
    if (!x.f || x.f[0] !== x.f[1]) return null;
    var mod = x.mod || (x.wd && x.wd[0]);  // closest focus: stated MOD, else where its working-distance range starts
    var f = x.f[0], mLo = CF_EXT / f, mHi = mLo + (mod && mod > f ? f / (mod - f) : 0);
    return [f * (1 + 1 / mHi), f * (1 + 1 / mLo)];
  }
  // ---- close focus: extension ring when the part is nearer than the lens focuses (fixed focal C-mount lenses) ---
  function tube(x, n, sys) {  // {len, rows: [add-on rows]} or null; extension L focuses m from L/f to L/f + m_at_MOD
    if (x.projection === "fisheye") return null;
    if (!n || !x.f || x.f[0] !== x.f[1] || !x.mod || n.wd >= x.mod * 0.95 || n.wd <= x.f[0] * 1.3) return null;
    if ((x.mt || []).indexOf("C-mount") < 0) return null;
    var f = x.f[0], mNeed = f / (n.wd - f), mMod = f / (x.mod - f), lo = f * (mNeed - mMod), hi = f * mNeed;
    var opts = [];
    if (sys.mount === "CS-mount") {  // one longer C-CS ring REPLACES the 5 mm adapter: 5 mm of it is the C-CS spacing
      ADD.forEach(function (a) { if (a.x.acc === "ccs" && a.x.len > 5) opts.push({ len: a.x.len - 5, rows: [a], replaces: true }); });
    } else if (!sys.mount || sys.mount === "C-mount") {  // C-C rings, and C-CS rings: C threads both sides = a C spacer
      var cc = ADD.filter(function (a) { return (a.x.acc === "cc" || a.x.acc === "ccs") && a.x.len; })
        .sort(function (a, b) { return a.x.len - b.x.len; });
      cc.forEach(function (a) { opts.push({ len: a.x.len, rows: [a] }); });
      for (var i = 0; i < cc.length; i++) for (var j = i; j < cc.length; j++) opts.push({ len: cc[i].x.len + cc[j].x.len, rows: [cc[i], cc[j]] });
    }
    opts = opts.filter(function (o) { return o.len >= lo && o.len <= hi; }).sort(function (a, b) { return a.len - b.len || a.rows.length - b.rows.length; });
    return opts[0] || null;
  }
  function fov(x, n) {  // field of view width x height this lens gives in the visitor's scene
    if (x.projection === "fisheye") return null;
    if (!n) return null;
    if (MAG[x.k] && x.mg) {
      var mg = Math.min(Math.max(n.m, x.mg[0]), x.mg[1]);
      return [n.s[0] / mg, n.s[1] / mg];
    }
    if (x.f && x.f[0] < n.wd) {
      var f = Math.min(Math.max(n.f, x.f[0]), x.f[1]), k = (n.wd - f) / f;
      return [n.s[0] * k, n.s[1] * k];
    }
    return null;
  }

  function fit(r, sys) {
    var x = r.x || {}, why = [], warn = null;
    if (!x.k) return [0, ""];
    // QA22c: a picked SWIR / UV / thermal camera takes lenses of its band only, a visible camera none of them
    if (sys.camera && (x.wl || sys.wl) && x.wl !== sys.wl)
      return [0, sys.wl ? T("lens.needs_band", "needs a {band} lens", { band: sys.wl }) : T("lens.band_cam", "{band} lens: needs a {band} camera", { band: x.wl })];
    var mf = null, cf = false;
    if (sys.mount) {
      if (!x.mt) return [1, T("lens.mount_unstated", "mount not stated")];
      mf = mountFit(x, sys);
      if (!mf) return [0, T("lens.mount_differs", "{lens} lens, {camera} camera", { lens: x.mt.join(" / "), camera: sys.mount })];
      why.push(mf.a ? T("lens.plus_adapter", "{mount} + adapter", { mount: mf.mt }) : mf.mt);
      cf = !!(mf.a && mf.a.x.acc === "cf");
      if (mf.a && mf.a.x.acc === "csm12" && mf.mt === "C-mount")  // the adapter's lens side is CS: a C lens also needs 5 mm
        warn = T("lens.c_on_board", "C lens on a board camera: M12 adapter + 5 mm C-CS ring; check the board's back focus");
    } else if (sys.camera) warn = T("lens.cam_mount_unstated", "your camera's lens mount is not stated");
    if (x.projection === "fisheye") return [1, T("lens.fisheye_check", "Fisheye lens: confirm image coverage, field of view and focus for your setup.")];
    if (cf) {  // C lens on an F camera: close-up only (the adapter is a 29 mm extension)
      var cr = cfRange(x), nn = need(sys);
      if (!cr) return [1, T("lens.cf_close_up", "C lens on an F camera: close-up only through the 29 mm C-F adapter")];
      var span = T("lens.cf_span", "about {near}-{far} mm from the part", { near: r1(cr[0]), far: r1(cr[1]) });
      if (!nn) return [1, T("lens.cf_focus", "C lens on an F camera: through the C-F adapter it focuses only at {span}", { span: span })];
      if (nn.wd < cr[0] * 0.95 || nn.wd > cr[1] * 1.05) return [0, T("lens.cf_focus_no", "Through the C-F adapter this lens focuses only at {span}", { span: span })];
      why.push(T("lens.cf_why", "close-up through the C-F adapter ({span})", { span: span }));
    }
    var sz = sys.kind === "line" ? sys.line_mm : sys.mm;
    if (sz) {
      if (!x.ic) warn = warn || T("lens.ic_unstated", "image circle not stated");
      else if (x.ic < sz * 0.97) return [0, T("lens.ic_small", "Image circle {ic} mm, sensor {sensor} mm", { ic: x.ic, sensor: r1(sz) })];
      else why.push(T("lens.covers", "covers the sensor"));
    }
    var lp = lensPx(x);
    if (sys.px && lp && lp > sys.px * 1.2) warn = warn || T("lens.px_coarse", "lens resolves about {lens} µm, camera pixels are {camera} µm", { lens: r1(lp), camera: sys.px });
    else if (!sys.px && sys.mp && x.mp && x.mp < sys.mp * 0.8) warn = warn || T("lens.mp_low", "rated {lens} MP for a {camera} MP camera", { lens: x.mp, camera: sys.mp });
    var n = need(sys);
    if (x.k === "s360") {  // 360° optics are chosen by the part's diameter, not by a field of view at a distance
      if (x.od) why.push(T("lens.parts_dia", "parts dia. {range}", { range: range(x.od, " mm") }));
    } else if (n && !cf) {
      if (MAG[x.k] || (!x.f && x.mg)) {
        if (!x.mg) return [1, T("lens.mag_unstated", "magnification not stated")];
        // the field it shows: more than asked (lower magnification, up to ~30%) fits; LESS than asked (higher
        // magnification, part may be cut off) is a check beyond 3%; further off either way does not fit
        var mg = Math.min(Math.max(n.m, x.mg[0]), x.mg[1]);
        if (mg > n.m * 1.33 || mg < n.m * 0.77) return [0, T("lens.mag_off", "{range}, your scene needs {need}x", { range: range(x.mg, "x"), need: r1(n.m) })];
        if (mg > n.m * 1.03) warn = warn || T("lens.mag_less", "{range}: shows only {w} mm wide, you asked {asked} mm", { range: range(x.mg, "x"), w: r1(n.s[0] / mg), asked: r1(n.s[0] / n.m) });
        else if (mg < n.m * 0.92) why.push(T("lens.mag_more", "shows a bit more ({w} mm wide)", { w: r1(n.s[0] / mg) }));
        if (x.k === "tele" && x.wd && Math.abs(n.wd - x.wd[0]) > 0.25 * x.wd[0])
          warn = warn || T("lens.tele_wd", "works at {range}, not {wd} mm", { range: range(x.wd, " mm"), wd: n.wd });
        why.push(r1(n.m) + "x");
      } else {
        if (!x.f) return [1, T("lens.f_unstated", "focal length not stated")];
        // the nearest standard focal length is what people buy: shorter (up to 30%) sees a bit more and fits;
        // longer shows LESS than asked (the part may not fit), so beyond 4% it is a check that says how far to move
        // back (up to 40%); further off does not fit
        var fl = Math.min(Math.max(n.f, x.f[0]), x.f[1]), v0 = fov(x, n);
        if (fl < n.f * 0.7 || fl > n.f * 1.4) return [0, T("lens.f_off", "{range} lens, your scene needs about {need} mm", { range: range(x.f, " mm"), need: r1(n.f) })];
        if (fl > n.f * 1.04) {  // thin lens: object distance for magnification m is f (1 + 1/m)
          warn = warn || T("lens.f_narrow", "narrower view: move back to about {wd} mm for your {w} mm field", { wd: r1(fl * (1 + 1 / n.m)), w: r1(n.s[0] / n.m) });
        } else if (fl < n.f * 0.87 && v0) why.push(T("lens.f_more", "sees a bit more ({w} mm wide)", { w: r1(v0[0]) }));
        var mod = x.mod || (x.wd && x.wd[0]);
        if (!mod && n.m > 0.3) warn = warn || T("lens.mod_unstated", "close-focus distance not stated; at {m}x a macro or telecentric lens is the usual choice", { m: r1(n.m) });
        if (mod && n.wd < mod * 0.95) {
          var t = tube(x, n, sys);
          if (!t) return [0, T("lens.mod_far", "Focuses from {mod} mm, your distance is {wd} mm", { mod: r1(mod), wd: n.wd })];
          why.push(T("lens.ring_why", "{len} mm extension ring for close focus", { len: t.len }));
        }
        why.push(range(x.f, " mm"));
      }
    }
    if (warn) return [1, warn];
    return [2, why.length ? T("lens.fits", "Fits: {list}", { list: why.join(", ") }) : ""];
  }

  // ---- the scene panel: sensor, distance, field of view, smallest feature -> diagram + what the scene needs -------
  function diagram(sys, n, sc) {
    var W = 560, H = 170, cy = 85, camX = 18, lensX = 112;
    var wd = sc.wd_mm || 300, fw = sc.fov_w_mm || 100;
    var objX = lensX + 40 + Math.min(360, 60 + 70 * Math.log(1 + wd / 40));  // log scale: 50 mm and 2 m both fit
    var half = Math.max(16, Math.min(70, 10 + 14 * Math.log(1 + fw / 5)));
    var t = function (x, y, s, a) { return '<text x="' + x + '" y="' + y + '"' + (a ? ' text-anchor="' + a + '"' : "") + ">" + s + "</text>"; };
    return '<svg class="cfgdia" viewBox="0 0 ' + W + " " + H + '" role="img" aria-label="' + T("lens.d_aria", "Camera, lens and field of view") + '">' +
      '<defs><linearGradient id="cfgbeam" x1="0" x2="1"><stop offset="0" stop-color="#19C3FF" stop-opacity=".45"/><stop offset="1" stop-color="#00E0C6" stop-opacity=".12"/></linearGradient></defs>' +
      '<polygon points="' + (lensX + 34) + "," + (cy - 9) + " " + objX + "," + (cy - half) + " " + objX + "," + (cy + half) + " " + (lensX + 34) + "," + (cy + 9) + '" fill="url(#cfgbeam)"/>' +
      '<rect x="' + camX + '" y="' + (cy - 26) + '" width="62" height="52" rx="6" class="cam"/>' + t(camX + 31, cy + 4, T("lens.d_camera", "camera"), "middle") +
      '<rect x="' + (camX + 62) + '" y="' + (cy - 11) + '" width="6" height="22" class="mnt"/>' +
      '<path d="M' + (lensX - 26) + "," + (cy - 15) + " L" + (lensX + 34) + "," + (cy - 20) + " L" + (lensX + 34) + "," + (cy + 20) + " L" + (lensX - 26) + "," + (cy + 15) + 'Z" class="lens"/>' +
      t(lensX + 4, cy + 4, n ? "≈" + r1(n.f) + " mm" : T("lens.d_lens", "lens"), "middle") +
      '<line x1="' + objX + '" y1="' + (cy - half) + '" x2="' + objX + '" y2="' + (cy + half) + '" class="obj"/>' +
      '<line x1="' + (lensX + 34) + '" y1="' + (H - 14) + '" x2="' + objX + '" y2="' + (H - 14) + '" class="dim"/>' +
      t((lensX + 34 + objX) / 2, H - 19, T("lens.d_wd", "working distance {wd}", { wd: sc.wd_mm ? sc.wd_mm + " mm" : "?" }), "middle") +
      t(objX + 8, cy - half + 10, T("lens.d_fov", "FOV {fov}", { fov: sc.fov_w_mm ? sc.fov_w_mm + (sc.fov_h_mm ? " x " + sc.fov_h_mm : "") + " mm" : "?" })) +
      (n ? t(objX + 8, cy - half + 26, T("lens.d_mag", "{m}x magnification", { m: r1(n.m) })) : "") +
      (sensor(sys) ? t(camX, 14, T("lens.d_sensor", "sensor {size} mm", { size: r1(sensor(sys)[0]) + (sensor(sys)[1] ? " x " + r1(sensor(sys)[1]) : "") }) +
        (sys.px ? ", " + T("lens.d_px", "{px} µm pixels", { px: sys.px }) : "")) : "") +
      "</svg>";
  }
  function verdict(sys, n, sc) {
    var s = sensor(sys);
    var B = function (s) { return "<b>" + s + "</b>"; };
    if (!s) return "<p>" + T("lens.v_sensor", "{sensor} (pick a camera in step 1, or the format here) and the lens list narrows to the right focal length.", { sensor: B(T("lens.v_sensor_b", "Tell us your sensor")) }) + "</p>";
    if (!n) return "<p>" + T("lens.v_enter", "Enter the {wd} (lens front to the part) and the {width} the camera must see.", { wd: B(T("lens.v_wd_b", "working distance")), width: B(T("lens.v_width_b", "width of the area")) }) + "</p>";
    var out = '<div class="cfgneed"><div><span>' + T("lens.v_fixed", "Fixed-focal lens") + '</span><b>≈ ' + r1(n.f) + ' mm</b></div><div><span>' + T("lens.v_tele", "Telecentric / macro") + "</span><b>" + r1(n.m) + "x</b></div>";
    var fx = sc.fov_w_mm, fy = s[1] ? s[1] / n.m : null;
    out += "<div><span>" + T("lens.v_see", "You will see") + "</span><b>" + r1(s[0] / n.m) + (fy ? " x " + r1(fy) : "") + " mm</b></div>";
    if (sys.px) {
      var opx = sys.px / 1000 / n.m;  // mm on the part per camera pixel
      out += "<div><span>" + T("lens.v_pixel", "One pixel on the part") + "</span><b>" + r1(opx * 1000) + " µm</b></div>";
      if (sc.feat_mm) {
        var across = sc.feat_mm / opx;
        out += '<div class="' + (across >= 3 ? "ok" : "no") + '"><span>' + T("lens.v_feature", "Smallest feature") + "</span><b>" + r1(across) + " px " + (across >= 3 ? "&#10003;" : "&#9888;") + "</b></div>";
      }
    }
    out += "</div>";
    if (sc.feat_mm && sys.px && sc.feat_mm / (sys.px / 1000 / n.m) < 3)
      out += '<p class="small">' + T("lens.v_3px", "Aim for at least 3 pixels across the smallest feature: narrow the field of view, move closer, or choose a camera with more pixels.") + "</p>";
    else if (sc.feat_mm && !sys.px) out += '<p class="small">' + T("lens.v_add_px", "Add your camera's pixel size to check the smallest feature.") + "</p>";
    if (fx && n.m > 0.5) out += '<p class="small">' + T("lens.v_macro", "At {m}x a macro or telecentric lens usually beats a fixed-focal lens with extension rings.", { m: r1(n.m) }) + "</p>";
    return out;
  }
  function top(el, api) {
    var sys = api.sys, sc = sys.scene || {}, n = need(sys), F = LSConfig.FORMAT_MM || {};
    var fmts = Object.keys(F).sort(function (a, b) { return F[a] - F[b]; });
    var known = !!(sys.camera || sys.w);
    var sensorBox = known ? "" :
      '<label class="fsel">' + api.esc(T("lens.sensor_format", "Sensor format")) + '<select name="fmt"><option value="">' + api.esc(T("lens.choose", "Choose")) + "</option>" + fmts.map(function (f) {
        return "<option" + (f === sys.fmt ? " selected" : "") + ">" + api.esc(f) + "</option>"; }).join("") + "</select></label>" +
      '<label class="fsel">' + api.esc(T("lens.pixel_size", "Pixel size (µm)")) + '<input type="number" min="0.5" step="any" name="px" value="' + (sys.px || "") + '" placeholder="' + api.esc(T("lens.eg", "e.g. {v}", { v: "3.45" })) + '"></label>' +
      '<label class="fsel">' + api.esc(T("lens.cam_mount", "Camera lens mount")) + '<select name="mt"><option value="">' + api.esc(T("lens.any_mount", "Any (shown as a check)")) + "</option>" + MOUNT_OPTS.map(function (m) {
        return "<option" + (m === sys.mount ? " selected" : "") + ">" + api.esc(m) + "</option>"; }).join("") + "</select></label>";
    var num = function (name, label, v, ph) {
      return '<label class="fsel">' + label + '<input type="number" min="0" step="any" name="' + name + '" value="' + (v || "") + '" placeholder="' + ph + '"></label>';
    };
    el.innerHTML = '<div class="cfgscene cfglens"><div class="cfgin">' + sensorBox +
      num("wd", T("lens.in_wd", "Working distance (mm)"), sc.wd_mm, T("lens.eg", "e.g. {v}", { v: "300" })) + num("fw", T("lens.in_fw", "Field of view width (mm)"), sc.fov_w_mm, T("lens.eg", "e.g. {v}", { v: "80" })) +
      num("fh", T("lens.in_fh", "Height (mm, optional)"), sc.fov_h_mm, T("lens.optional", "optional")) + num("ft", T("lens.in_ft", "Smallest feature (mm)"), sc.feat_mm, T("lens.optional", "optional")) +
      '<p class="cfgex">' + T("lens.try", "Try:") + " " + EXAMPLES.map(function (e, i) { return '<button type="button" class="linkbtn" data-ex="' + i + '">' + api.esc(e[0]) + "</button>"; }).join(" · ") + "</p></div>" +
      '<div class="cfgout">' + ((sys.lens || {}).projection === "fisheye" ? '<p>' + api.esc(T("lens.fisheye_check", "Fisheye lens: confirm image coverage, field of view and focus for your setup.")) + '</p>' : diagram(sys, n, sc) + verdict(sys, n, sc)) + "</div></div>";
    var t = null;
    var read = function () {
      var g = function (k) { var i = el.querySelector("[name=" + k + "]"); return i ? parseFloat(i.value) : NaN; };
      var wd = g("wd"), fw = g("fw"), fh = g("fh"), ft = g("ft"), fmt = el.querySelector("[name=fmt]"), px = g("px");
      var mtSel = el.querySelector("[name=mt]");
      if (fmt && (fmt.value || px > 0 || (mtSel && mtSel.value !== (sys.mount || "")))) {  // lens-only visitors: the sensor typed here becomes "your camera"
        var h = {};
        ["mount", "fmt", "iface", "kind"].forEach(function (k) { if (sys[k]) h[k] = sys[k]; });
        if (mtSel) { if (mtSel.value) h.mount = mtSel.value; else delete h.mount; }
        if (fmt.value) { h.fmt = fmt.value; h.mm = F[fmt.value]; }
        if (px > 0) h.px = px;
        if (JSON.stringify(h) !== JSON.stringify({ mount: sys.mount, fmt: sys.fmt, mm: sys.mm, px: sys.px })) api.have(h);
      }
      var s = {};  // keep what is typed so far; need() computes once distance and width are both there
      if (wd > 0) s.wd_mm = wd;
      if (fw > 0) s.fov_w_mm = fw;
      if (fh > 0) s.fov_h_mm = fh;
      if (ft > 0) s.feat_mm = ft;
      api.set("scene", s);
      top(el, api);
      if (LOADED) api.refresh();  // the panel may be drawn before the lens list has loaded (no layout shift)
    };
    el.oninput = function (ev) {
      if (ev.target.tagName === "SELECT") return;
      clearTimeout(t);
      t = setTimeout(function () {
        var a = document.activeElement, name = a && a.name, pos = a && a.selectionStart;
        read();
        var b = name && el.querySelector("[name=" + name + "]");
        if (b) { b.focus(); try { b.setSelectionRange(pos, pos); } catch (e) { /* number inputs */ } }
      }, 450);
    };
    el.onchange = function (ev) { if (ev.target.tagName === "SELECT") read(); };
    el.onclick = function (ev) {
      var b = ev.target.closest("[data-ex]");
      if (!b) return;
      var e = EXAMPLES[+b.dataset.ex];
      el.querySelector("[name=wd]").value = e[1];
      el.querySelector("[name=fw]").value = e[2];
      el.querySelector("[name=fh]").value = "";
      el.querySelector("[name=ft]").value = e[3];
      read();
    };
  }

  // ---- compare: up to 4 lenses side by side (a button on each lens card, a tray, a table with Select per column) ----
  var CMP = [], API = null, OBS = null, MAX_CMP = 4;
  var KIND_LABEL = {};
  KINDS.forEach(function (k) { KIND_LABEL[k[0]] = k[1]; });
  function cmpSpec(r, sys) {  // [label, value] rows of the table; "" when the lens does not state it
    var x = r.x || {}, n = need(sys), v = fov(x, n), f = fit(r, sys);
    var esc = API.esc;
    return [
      [T("lens.c_price", "Price"), r.p != null ? API.money(r.p) : T("lens.c_on_request", "Price on request")],
      [T("lens.c_type", "Type"), KIND_LABEL[x.k] || ""],
      [T("lens.c_f", "Focal length"), x.f ? range(x.f, " mm") : ""],
      [T("lens.c_mag", "Magnification"), x.mg ? range(x.mg, "x") : ""],
      [T("lens.c_fnum", "F-number"), x.F ? "F" + x.F[0] + (x.F[1] > x.F[0] ? " - F" + x.F[1] : "") : ""],
      [T("lens.c_ic", "Image circle"), x.projection === "fisheye" && x.ic_basis !== "stated" ? T("lens.ic_unstated", "image circle not stated") : x.ic ? (x.ic_basis && x.ic_basis !== "stated" ? "≈ " : "") + x.ic + " mm" + (x.fm ? " (" + x.fm + ")" : "") : x.fm || ""],
      [T("lens.c_res", "Resolution"), [x.mp ? x.mp + " MP" : "", x.px ? x.px + " µm" : ""].filter(Boolean).join(", ")],
      [T("lens.c_mount", "Mount"), (x.mt || []).join(" / ")],
      [T("lens.c_wd", "Working distance"), x.wd ? range(x.wd, " mm") : ""],
      [T("lens.c_mod", "Closest focus"), x.mod ? r1(x.mod) + " mm" : ""],
      [T("lens.c_dist", "Distortion"), x.ds != null ? x.ds + " %" : ""],
      [T("lens.c_tc", "Telecentricity"), x.tc != null ? x.tc + "°" : ""],
      [T("lens.c_thread", "Filter thread"), x.ft || ""],
      [T("lens.c_iris", "Iris"), x.iris || ""],
      [T("lens.c_fov", "Field of view at your distance"), v ? r1(v[0]) + (v[1] ? " x " + r1(v[1]) : "") + " mm" : ""],
      [T("lens.c_fit", "Fit for your system"), '<span class="fit ' + (f[0] === 2 ? "ok" : f[0] === 1 ? "check" : "no") + '">' +
        esc(f[0] === 1 ? T("lens.c_check", "Check: {reason}", { reason: f[1] || T("lens.c_unstated", "not stated") }) : f[1] || (f[0] === 2 ? T("lens.c_fits", "Fits") : T("lens.c_no_fit", "Does not fit"))) + "</span>"]
    ];
  }
  function cmpTable() {
    var rows = CMP.map(function (h) { return API.row(h); }).filter(Boolean), sys = API.sys, esc = API.esc;
    if (!rows.length) return;
    var specs = rows.map(function (r) { return cmpSpec(r, sys); });
    var body = specs[0].map(function (s, i) {
      var vals = specs.map(function (sp) { return sp[i][1]; });
      if (vals.every(function (v) { return !v; })) return "";
      var differ = vals.some(function (v) { return v !== vals[0]; });
      return "<tr" + (differ ? ' class="diff"' : "") + "><th>" + esc(s[0]) + "</th>" + vals.map(function (v, j) {
        return "<td>" + (i === specs[0].length - 1 ? v : esc(v || "-")) + "</td>";
      }).join("") + "</tr>";
    }).join("");
    var head = "<tr><th></th>" + rows.map(function (r) {
      return '<td class="lshead"><img src="' + esc(r.i) + '" alt="" loading="lazy"><a href="' + esc(LSConfig.url(r)) + '\" target="_blank" rel="noopener">' +
        esc(r.m) + "</a><span>" + esc(r.t) + '</span><button type="button" class="btn" data-cmp-pick="' + esc(r.h) + '">' + esc(T("lens.c_select", "Select")) + "</button>" +
        '<button type="button" class="linkbtn" data-cmp-rm="' + esc(r.h) + '">' + esc(T("lens.c_remove", "Remove")) + "</button></td>";
    }).join("") + "</tr>";
    var m = document.querySelector(".lsmodal") || document.body.appendChild(document.createElement("div"));
    m.className = "lsmodal";
    m.innerHTML = '<div class="lsshade" data-cmp-close></div><div class="lsbox" role="dialog" aria-label="' + esc(T("lens.c_title", "Compare lenses")) + '">' +
      '<div class="lsboxhead"><b>' + esc(T("lens.c_title", "Compare lenses")) + '</b><span class="muted small">' + esc(T("lens.c_diff", "Rows that differ are highlighted")) + "</span>" +
      '<button type="button" class="cartx" data-cmp-close aria-label="' + esc(T("lens.c_close", "Close")) + '">&times;</button></div>' +
      '<div class="tablewrap"><table class="lscmpt"><thead>' + head + "</thead><tbody>" + body + "</tbody></table></div></div>";
    document.body.classList.add("cartopen");
  }
  function cmpClose() {
    var m = document.querySelector(".lsmodal");
    if (m) m.remove();
    document.body.classList.remove("cartopen");
  }
  function cmpTray() {
    var t = document.querySelector(".lstray"), onLens = !!document.querySelector(".cfglens");
    if (!CMP.length || !onLens) { if (t) t.remove(); return; }
    if (!t) { t = document.createElement("div"); t.className = "lstray"; document.body.appendChild(t); }
    var cnt = { n: "<b>" + CMP.length + "</b>" };
    t.innerHTML = "<span>" + (CMP.length > 1 ? T("lens.tray_other", "Compare {n} lenses", cnt) : T("lens.tray_one", "Compare {n} lens", cnt)) + "</span>" +
      '<button type="button" class="btn" data-cmp-show' + (CMP.length < 2 ? " disabled" : "") + ">" + T("lens.tray_show", "Compare side by side") + "</button>" +
      '<button type="button" class="linkbtn" data-cmp-clear>' + T("lens.tray_clear", "Clear") + "</button>";
  }
  function cmpDecorate(root) {
    if (root.querySelector(".cfglens")) {
      Array.prototype.forEach.call(root.querySelectorAll(".cfgcard .cfgbuy"), function (buy) {
        if (buy.querySelector(".lscmp")) return;
        var h = buy.closest(".cfgcard").dataset.h, on = CMP.indexOf(h) >= 0, b = document.createElement("button");
        b.type = "button";
        b.className = "lscmp" + (on ? " on" : "");
        b.setAttribute("data-cmp", h);
        b.textContent = on ? "✓ " + T("lens.compare", "Compare") : T("lens.compare", "Compare");
        buy.appendChild(b);
      });
    }
    cmpTray();
  }
  function cmpClick(ev) {
    var b = ev.target.closest("[data-cmp],[data-cmp-show],[data-cmp-clear],[data-cmp-close],[data-cmp-pick],[data-cmp-rm]");
    if (!b || !API) return;
    var h = b.getAttribute("data-cmp") || b.getAttribute("data-cmp-rm");
    if (b.hasAttribute("data-cmp")) {
      var i = CMP.indexOf(h);
      if (i >= 0) CMP.splice(i, 1);
      else if (CMP.length >= MAX_CMP) { if (window.LSConfig) window.LSConfig.toast(T("lens.tray_max", "Compare up to {n} lenses at a time.", { n: MAX_CMP })); return; }
      else CMP.push(h);
      b.classList.toggle("on", CMP.indexOf(h) >= 0);
      b.textContent = CMP.indexOf(h) >= 0 ? "✓ " + T("lens.compare", "Compare") : T("lens.compare", "Compare");
      cmpTray();
    } else if (b.hasAttribute("data-cmp-show")) cmpTable();
    else if (b.hasAttribute("data-cmp-clear")) {
      CMP = [];
      Array.prototype.forEach.call(document.querySelectorAll(".lscmp.on"), function (x) { x.classList.remove("on"); x.textContent = T("lens.compare", "Compare"); });
      cmpTray();
    } else if (b.hasAttribute("data-cmp-close")) cmpClose();
    else if (b.hasAttribute("data-cmp-rm")) {
      CMP = CMP.filter(function (x) { return x !== h; });
      var c = document.querySelector('.lscmp[data-cmp="' + h + '"]');
      if (c) { c.classList.remove("on"); c.textContent = T("lens.compare", "Compare"); }
      cmpTray();
      if (CMP.length) cmpTable(); else cmpClose();
    } else if (b.hasAttribute("data-cmp-pick")) {
      var ph = b.getAttribute("data-cmp-pick"), r = API.row(ph);
      cmpClose();
      API.pick(ph, "", 1);
      if (r) DEF.onPick(r, API);
      CMP = [];
      API.next();
    }
  }
  function cmpInit(api) {
    API = api;
    if (OBS) return;
    var main = document.querySelector("[data-cfg-main]");
    if (!main || !window.MutationObserver) return;
    OBS = new MutationObserver(function () { cmpDecorate(main); });
    OBS.observe(main, { childList: true, subtree: true });
    document.addEventListener("click", cmpClick);
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") cmpClose(); });
  }

  var DEF = {
    load: function (d) { ADD = d.rows.filter(function (r) { return r.addon && r.x && r.x.acc; }); LOADED = true; },
    filters: ["Focal length", "Magnification", "Working distance", "Sensor format", "Mount", "Resolution", "Image circle"],
    chips: ["Resolution", "Sensor format"],
    groups: KINDS,
    group: function (r) { return (r.x || {}).k; },
    skip: T("lens.skip", "No lens needed"),
    fit: fit,
    rank: function (r, sys) {  // closest to the focal length / magnification the scene needs; cheaper first on ties
      var x = r.x || {}, n = need(sys), p = (r.p || 5000) / 1e6;
      var pref = (x.k in PREF ? PREF[x.k] : 0.15) + ((x.k === "line") !== (sys.kind === "line") ? 1 : 0);
      if (x.projection === "fisheye") return pref + 0.3 + p;
      if (!n) return p;
      if (MAG[x.k] && x.mg) return pref + Math.abs(Math.log(n.m / Math.min(Math.max(n.m, x.mg[0]), x.mg[1]))) + p;
      var t = x.f && !MAG[x.k] ? tube(x, n, sys) : null;  // long extension rings: macro / telecentric optics do it better
      if (t) pref += 0.05 + Math.min(0.6, t.len / x.f[0]);
      var mf = mountFit(x, sys);  // a native mount before one that needs an adapter (C lens on an M12 board camera last)
      if (mf && mf.a) pref += mf.a.x.acc === "csm12" ? 0.5 : mf.a.x.acc === "cf" ? 0.8 : 0.12;  // C-F: close-up only
      if (x.f) return pref + Math.abs(Math.log(n.f / Math.min(Math.max(n.f, x.f[0]), x.f[1]))) + p;
      return null;
    },
    extra: function (r, sys) {
      var x = r.x || {}, out = [], v = x.k === "s360" ? null : fov(x, need(sys));  // 360°: a FOV at a distance means nothing
      if (x.f) out.push(range(x.f, " mm"));
      if (x.mg) out.push(range(x.mg, "x"));
      if (x.F) out.push("F" + x.F[0]);
      if (x.mt) out.push(x.mt[0]);
      if (v) out.push(T("lens.x_fov", "FOV {fov} mm", { fov: r1(v[0]) + (v[1] ? " x " + r1(v[1]) : "") }));
      else if (x.wd && !need(sys)) out.push(T("lens.x_wd", "WD {range}", { range: range(x.wd, " mm") }));
      if (x.cx) out.push(T("lens.x_coax", "coaxial port"));
      if (x.lf) out.push(x.lf);
      if (x.vw) out.push(x.vw);
      if (x.od) out.push(T("lens.parts_dia", "parts dia. {range}", { range: range(x.od, " mm") }));
      return out;
    },
    note: function (sys) {
      var n = need(sys), cam = [sys.camera, sys.mount, sys.fmt, sys.kind === "line" && sys.line_mm ? T("lens.n_line", "{mm} mm line", { mm: sys.line_mm }) : ""].filter(Boolean).join(", ");
      var head = cam ? T("lens.n_camera", "Showing lenses for your camera ({camera}).", { camera: cam }) : T("lens.n_none", "No camera yet: the list covers every lens; enter your sensor below to check the fit.");
      if (n) return head + " " + T("lens.n_best", "Best matches first, closest to {f} (or {m} for telecentric and macro).", { f: "<b>" + r1(n.f) + " mm</b>", m: "<b>" + r1(n.m) + "x</b>" });
      return head;
    },
    top: function (el, api) { cmpInit(api); top(el, api); },
    onPick: function (r, api) {
      var x = r.x || {}, sys = api.sys, mf = mountFit(x, sys), notes = [];
      var cf = !!(mf && mf.a && mf.a.x.acc === "cf");
      var t = (MAG[x.k] || !x.f || cf) ? null : tube(x, need(sys), sys);
      if (mf && mf.a && !(t && t.replaces)) {  // a longer C-CS ring (t.replaces) already does the 5 mm C-CS spacing
        api.add(mf.a.h, "", 1);
        notes.push(cf && x.projection !== "fisheye" ? T("lens.p_adapter_cf", "{adapter} adapter added for your {mount} camera (close-up only: it adds 29 mm)", { adapter: mf.a.m, mount: sys.mount })
          : T("lens.p_adapter", "{adapter} adapter added for your {mount} camera", { adapter: mf.a.m, mount: sys.mount }));
        if (mf.a.x.acc === "csm12" && mf.mt === "C-mount") {  // CS-side adapter: a C lens also needs the 5 mm C-CS ring
          var ring = ADD.filter(function (a) { return a.x.acc === "ccs" && a.x.len === 5; })[0];
          if (ring) { api.add(ring.h, "", 1); notes.push(T("lens.p_ring", "{ring} 5 mm ring for the C-mount lens", { ring: ring.m })); }
        }
      }
      if (t) {
        var qty = {};
        t.rows.forEach(function (a) { qty[a.h] = (qty[a.h] || 0) + 1; });
        Object.keys(qty).forEach(function (h) { api.add(h, "", qty[h]); });
        var stack = t.rows.reduce(function (s, a) { return s + a.x.len; }, 0);
        var tv = { rings: t.rows.map(function (a) { return a.m; }).join(" + "), stack: stack, len: t.len, wd: need(sys).wd };
        notes.push(t.replaces ? T("lens.p_tube_ccs", "{rings} ({stack} mm: 5 mm C-CS spacing + {len} mm extension) to focus at {wd} mm", tv)
          : T("lens.p_tube", "{rings} ({stack} mm extension) to focus at {wd} mm", tv));
      }
      if (notes.length) api.note(notes.join("; "));
    },
    apply: function (r, p, sys) {
      var x = r.x || {}, mf = mountFit(x, sys) || { mt: (x.mt || [])[0] };
      sys.lens = { mount: mf.mt || (x.mt || [])[0], mm: x.ic, ic_basis: x.ic_basis, ring: (p.add || []).length > 0, ft: x.ft, k: x.k, wl: x.wl, projection: x.projection };  // k: lens type (extras shows telecentric add-ons for "tele")
    }
  };
  LSConfig.step("lens", DEF);
})();

/* light.js */
// Light step: any machine-vision light; its supply voltage and count set what the controller step shows. With the
// field of view from the lens step, area lights (backlight, coaxial, collimated) must cover the field and bar / line
// lights should be at least as long as it; the closest size that covers it comes first.
(function () {
  var AREA = { "Backlights": 1, "Coaxial lights": 1, "Collimated lights": 1 };
  var LINEAR = { "Bar lights": 1, "Line scan lights": 1 };
  var r0 = function (v) { return Math.round(v); };
  var T = LSConfig.t;  // customer text (core.js)
  var size = function (f) { return r0(f[0]) + (f[1] ? " x " + r0(f[1]) : ""); };  // "120 x 90" (mm) of the field
  function field(sys) {  // [width, height] mm the camera sees, from the lens step's scene
    var sc = sys.scene;
    if (!sc || !sc.fov_w_mm) return null;
    var ratio = sys.w && sys.hh ? sys.hh / sys.w : sys.kind === "line" ? 0 : 0.75;
    return [sc.fov_w_mm, sc.fov_h_mm || sc.fov_w_mm * ratio];  // a typed field height wins over the sensor ratio
  }
  function cover(r, sys) {  // [score, why, excess] for the visitor's field
    var x = r.x || {}, f = field(sys);
    if (!f) return null;
    if (AREA[r.c]) {
      if (!x.em) return [1, T("light.area_unstated", "emitting area not stated"), 9];
      var big = Math.max(x.em[0], x.em[1]), small = Math.min(x.em[0], x.em[1]);
      if (big >= Math.max(f[0], f[1]) && small >= Math.min(f[0], f[1]))
        return [2, T("light.covers", "Covers your {field} mm field", { field: size(f) }), (big * small) / Math.max(f[0] * Math.max(f[1], 1), 1)];
      return [0, T("light.area_small", "Emitting area {w} x {h} mm, field {field} mm", { w: r0(x.em[0]), h: r0(x.em[1]), field: size(f) }), 9];
    }
    if (LINEAR[r.c]) {
      if (!x.len) return [1, T("light.length_unstated", "length not stated"), 9];
      if (x.len >= f[0]) return [2, T("light.spans", "Spans your {w} mm field", { w: r0(f[0]) }), x.len / f[0]];
      return [1, T("light.use_two", "{len} mm long, field {w} mm (use two)", { len: r0(x.len), w: r0(f[0]) }), 9];
    }
    return null;
  }
  LSConfig.step("light", {
    filters: ["Colour", "Size", "Voltage"],
    chips: ["Size", "Voltage"],
    qty: true,
    skip: T("light.skip", "No light needed"),
    fit: function (r, sys) {
      var c = cover(r, sys);
      if (c) return [c[0], c[1]];
      if (sys.kind === "line" && r.c === "Line scan lights") return [2, T("light.line_scan", "Made for line-scan cameras")];
      return [2, ""];
    },
    // lights whose size is checked against the field come first (closest cover first); ring / dome / spot / shadowless
    // lights, whose size is not compared with the field, follow them
    rank: function (r, sys) { var c = cover(r, sys); return c ? Math.log(Math.max(c[2], 1)) : field(sys) ? 1.5 : 0; },
    note: function (sys) {
      var f = field(sys), g = T("light.guide", "Not sure which type? The {link} matches the light to the defect you need to see.",
        { link: '<a href="/pages/guide" target="_blank" rel="noopener">' + T("light.guide_link", "lighting selection guide") + "</a>" });
      return f ? T("light.note_field", "Sizes are checked against your {field} mm field of view (lens step).", { field: size(f) }) + " " + g : g;
    },
    apply: function (r, p, sys) {
      var x = r.x || {};
      sys.light = { volt: x.volt || [], w: x.w, n: p.n, conn: x.conn, model: r.m, rec: x.rec || [], recs: x.recs || [], strobe: !!x.strobe };
    }
  });
})();

/* controller.js */
// Light controller step: constant-voltage output matching the light's supply, enough channels for the lights, and
// enough power per channel for one light (when both figures are printed; flash / strobe lights are rated in pulse
// power, so they skip it). The controller the light's maker recommends comes first, then its recommended series,
// then the smallest controller that fits.
(function () {
  var T = LSConfig.t;  // customer text (core.js)
  LSConfig.step("controller", {
    filters: ["Channels", "Output", "Control"],
    chips: ["Channels", "Output", "Control"],
    skip: T("controller.skip", "No controller needed"),
    extra: function (r) { var x = r.x || {}; return x.pw ? [T("controller.w_per_ch", "{w} W per channel", { w: x.pw })] : []; },
    fit: function (r, sys) {
      var l = sys.light, x = r.x || {};
      if (!l) return [2, ""];
      if ((l.rec || []).indexOf(r.m.toUpperCase()) >= 0) return [2, T("controller.recommended", "Recommended for this light by its maker")];
      if (l.w && x.pw && x.pw < l.w && !l.strobe) return [0, T("controller.low_power", "{w} W per channel, your light draws up to {light_w} W", { w: x.pw, light_w: l.w })];
      var series = (l.recs || []).some(function (s) { var m = r.m.toUpperCase(); return m.indexOf(s) === 0 && /[0-9]/.test(m.charAt(s.length)); });
      if (!l.volt.length) return [1, series ? T("controller.series_no_volt", "a series the light's maker recommends; its voltage is not stated") : T("controller.no_volt", "your light's voltage is not stated")];
      if (!x.cv && !x.cc) return [1, T("controller.output_unstated", "output not stated")];
      var ok = (x.cv || []).filter(function (v) { return l.volt.indexOf(v) >= 0; });
      if (!ok.length) return [0, x.cv ? T("controller.volt_differs", "Output {out} V, light needs {need} V", { out: x.cv.join("/"), need: l.volt.join("/") }) : T("controller.cc_only", "Constant-current output; your light runs on {need} V", { need: l.volt.join("/") })];
      if (x.ch && x.ch < l.n) return [1, x.ch > 1 ? T("controller.channels_other", "{n} channels for {lights} lights (or order two)", { n: x.ch, lights: l.n }) : T("controller.channels_one", "{n} channel for {lights} lights (or order two)", { n: x.ch, lights: l.n })];
      var cn = LSConfig.conn || function () { return ""; }, lc = cn(l.conn), xc = cn(x.conn);
      if (lc && xc && lc !== xc) return [1, T("controller.conn_differs", "Drives {v} V; connectors differ (light {light}, controller {ctl}): needs an adapter cable", { v: ok[0], light: l.conn, ctl: x.conn.replace(/\s*\(.*$/, "") })];
      if (l.w && !x.pw) return [1, T("controller.power_unstated", "Drives {v} V; power per channel not stated (light {light_w} W)", { v: ok[0], light_w: l.w })];
      return [2, l.w && x.pw ? T("controller.drives_w", "Drives your {v} V, {light_w} W light", { v: ok[0], light_w: l.w }) : T("controller.drives", "Drives your {v} V light", { v: ok[0] })];
    },
    rank: function (r, sys) {  // the smallest controller that still has the power and channels
      var x = r.x || {}, l = sys.light, m = r.m.toUpperCase();
      if (!l) return 0;
      if ((l.rec || []).indexOf(m) >= 0) return -10;
      var series = (l.recs || []).some(function (s) { return m.indexOf(s) === 0 && /[0-9]/.test(m.charAt(s.length)); }) ? -1 : 0;
      return series + (x.pw && l.w ? Math.abs(Math.log(x.pw / l.w)) : 2) + (x.ch && l.n ? Math.abs(x.ch - l.n) * 0.05 : 0.2);
    },
    note: function (sys) {
      var l = sys.light;
      if (!l) return T("controller.note_none", "No light chosen, so every controller is listed.");
      return l.volt.length ? (l.w ? T("controller.note_w", "Showing controllers for {n} x {model} ({volt} V, up to {w} W).", { n: l.n, model: l.model, volt: l.volt.join(" / "), w: l.w }) :
        T("controller.note", "Showing controllers for {n} x {model} ({volt} V).", { n: l.n, model: l.model, volt: l.volt.join(" / ") })) :
        T("controller.note_no_volt", "Your light's datasheet gives no supply voltage, so the list is not filtered. Most of our lights with a stated voltage run on 24 V.");
    }
  });
})();

/* pc.js */
// PC step: a port for the camera's interface (LAN for GigE, USB 3 for USB3 cameras, a PCIe slot for a CoaXPress /
// Camera Link frame grabber or a 10 GbE card). Vision controllers come first (trigger I/O, and on many models
// built-in light outputs that can replace the light controller), then the cheapest that fits.
(function () {
  var T = LSConfig.t;  // customer text (core.js)
  var rate = function (i) { var m = /^(\d+(?:\.\d+)?)?GigE$/.exec(i || ""); return m ? Number(m[1] || 1) : null; };
  LSConfig.step("pc", {
    filters: ["Processor", "LAN ports", "USB 3 ports", "PoE", "Light outputs"],
    chips: ["Processor", "LAN ports", "USB 3 ports", "Memory"],
    skip: T("pc.skip", "I have a PC"),
    group: function (r) { return r.c; },
    extra: function (r, sys) {
      var x = r.x || {}, out = [];
      if (x.lch) out.push(sys.light ? T("pc.light_outputs_drive", "{n} built-in light outputs: can drive your light", { n: x.lch }) : T("pc.light_outputs", "{n} built-in light outputs", { n: x.lch }));
      if (x.poe) out.push("PoE");
      return out;
    },
    fit: function (r, sys) {
      var x = r.x || {}, i = sys.iface, g = rate(i);
      if (!i) return [2, ""];
      if (g && g > 1) {
        if (x.g10) return [2, T("pc.g10", "10 GbE port for your {iface} camera", { iface: i })];
        if (x.pcie === 1) return [1, T("pc.g10_card", "Your {iface} camera needs a 10 GbE network card in the PCIe slot (or runs at 1 Gb/s on a LAN port)", { iface: i })];
        return [1, T("pc.g10_none", "{iface} camera: no 10 GbE port stated, so it would run at 1 Gb/s", { iface: i })];
      }
      if (g) {
        if (x.lan) return [2, x.lan > 1 ? (x.poe ? T("pc.lan_poe_other", "{n} LAN ports with PoE for your GigE camera", { n: x.lan }) : T("pc.lan_other", "{n} LAN ports for your GigE camera", { n: x.lan }))
          : (x.poe ? T("pc.lan_poe_one", "{n} LAN port with PoE for your GigE camera", { n: x.lan }) : T("pc.lan_one", "{n} LAN port for your GigE camera", { n: x.lan }))];
        return [1, T("pc.lan_unstated", "LAN ports not stated")];
      }
      if (/^USB\s?3/.test(i)) return x.usb3 ? [2, x.usb3 > 1 ? T("pc.usb3_other", "{n} USB 3 ports for your USB3 camera", { n: x.usb3 }) : T("pc.usb3_one", "{n} USB 3 port for your USB3 camera", { n: x.usb3 })] : [1, T("pc.usb3_unstated", "USB 3 ports not stated")];
      if (/CoaXPress|Camera Link|XoF|XoC/i.test(i)) {
        if (x.pcie === 1) return [2, T("pc.pcie", "PCIe slot for the {iface} frame grabber (Cables & extras step)", { iface: i })];
        if (x.pcie === 0) return [0, T("pc.pcie_none", "No PCIe slot for the {iface} frame grabber", { iface: i })];
        return [1, T("pc.pcie_unstated", "Needs a PCIe slot for the {iface} frame grabber; not stated", { iface: i })];
      }
      return [1, T("pc.check_port", "Check the PC has a {iface} port", { iface: i })];
    },
    rank: function (r, sys) {
      var x = r.x || {};
      var k = { vc: 0, ipc: 1, panel: 2 }[x.kind];
      return (k == null ? 3 : k) * 1e5 + (sys.light && x.lch ? -5e4 : 0) + (r.p || 9e4);
    },
    note: function (sys) {
      if (!sys.iface) return T("pc.note_none", "No camera chosen, so every PC is listed. Vision controllers come first: they have trigger I/O and camera ports.");
      var v = { camera: sys.camera || "", iface: sys.iface };
      return sys.light ? T("pc.note_light", "Showing PCs with a port for your {camera} ({iface}). Vision controllers come first; those with built-in light outputs can drive your light without a separate controller.", v)
        : T("pc.note", "Showing PCs with a port for your {camera} ({iface}). Vision controllers come first.", v);
    },
    apply: function (r, p, sys) { var x = r.x || {}; sys.pc = { model: r.m, lch: x.lch || 0, kind: x.kind }; }
  });
})();

/* trigger.js */
// Trigger sensor step: a photoelectric sensor tells the camera (or vision controller) that a part is in view. Every
// sensor fits; the visitor picks by mounting type, range and output. The output must match the input it is wired to.
(function () {
  var T = LSConfig.t;  // customer text (core.js)
  LSConfig.step("trigger", {
    filters: ["Type", "Output", "Sensing range", "Light source"],
    chips: ["Type", "Output", "Sensing range"],
    skip: T("trigger.skip", "No trigger sensor"),
    fit: function () { return [2, ""]; },
    rank: function (r) { return r.p || 1e5; },
    note: function (sys) {
      var tail = T("trigger.note_tail", "Through-beam reaches farthest; diffuse-reflective needs no reflector. Choose NPN or PNP to match that input.");
      return (sys.pc && sys.pc.kind === "vc" ? T("trigger.note_vc", "Wire the sensor's output to the {model}'s or the camera's trigger input.", { model: sys.pc.model })
        : T("trigger.note", "Wire the sensor's output to the camera's trigger input.")) + " " + tail;
    }
  });
})();

/* extras.js */
// Cables & extras: groups of add-on parts (rows carry x.g, see extras.py), each filtered to what the system needs.
(function () {
  var T = LSConfig.t;  // customer text (core.js)
  var GROUPS = [
    { g: "data", label: T("extras.data", "Camera data cable"), why: function (s) { return s.iface ? T("extras.for_iface", "for {iface}", { iface: s.iface }) : ""; } },
    { g: "io", label: T("extras.io", "Camera power and I/O cable"), why: function (s) { return s.io ? T("extras.io_why", "for the {pins}-pin I/O connector", { pins: s.io }) : ""; } },
    { g: "adapter", label: T("extras.adapter", "Lens adapters, extension tubes and filters"), why: function (s) { return s.mount ? T("extras.for_mount", "for your {mount} camera", { mount: s.mount }) : ""; } },
    { g: "tele", label: T("extras.tele", "Telecentric accessories"), why: function () { return T("extras.tele_why", "prisms, calibration targets, front groups, extenders"); } },
    { g: "light", label: T("extras.light", "Light extension cable"), why: function (s) { return s.light ? T("extras.light_why", "between the light and the controller") : ""; } },
    { g: "grabber", label: T("extras.grabber", "Frame grabber"), why: function (s) { return s.iface ? T("extras.for_iface", "for {iface}", { iface: s.iface }) : ""; } },
    { g: "gio", label: T("extras.gio", "Frame grabber I/O cable"), why: function () { return T("extras.gio_why", "trigger and I/O for the grabber"); } },
    { g: "power", label: T("extras.power", "Power cords and supplies"), why: function () { return ""; } }
  ];
  var SHOW = 4, open = {};
  var needsRing = function (s) { return s.mount === "CS-mount" && s.lens && s.lens.mount === "C-mount" && !s.lens.ring; };  // the lens step adds it
  // link speed in Gbit/s for GigE-family interfaces ("10GigE" -> 10, "GigE" -> 1); null for the others
  var rate = function (i) { var m = /^(\d+(?:\.\d+)?)?GigE$/.exec(i || ""); return m ? parseFloat(m[1] || "1") : null; };
  // connector names as the lights, cables and controllers print them -> one comparable code: "Dual-channel SMR-03V-B",
  // "SMP-03V-BC" (the mating JST housing) -> "SMR-03V-B"; "24M-6J/24J6TQ aviation plug" -> "24M-6J"
  var conn = function (c) {
    var s = String(c || "").toUpperCase().replace(/\(.*?\)/g, " ").replace(/DUAL-CHANNEL|AVIATION( PLUG| CONNECTOR)?|FEMALE|MALE|PLUG/g, " ");
    var m = /[A-Z0-9]+(?:-[A-Z0-9]+)+/.exec(s);
    if (!m) return s.replace(/\s+/g, " ").trim();  // codes without a hyphen ("SM3", "3-pin flat" after facets.connector)
    return m[0].replace(/^SMP-/, "SMR-").replace(/(-[A-Z])C$/, "$1");
  };
  var MOUNT = { "C-mount": "C", "CS-mount": "CS", "F-mount": "F", "EF-mount": "EF", "V-mount": "V" };
  function fit(r, s) {
    var x = r.x || {};
    switch (x.g) {
      case "data": case "grabber":
        if (!s.iface) return [1, T("extras.choose_camera", "choose a camera to match")];
        if (!x.iface) return [1, T("extras.iface_unstated", "interface not stated")];
        var cr = rate(s.iface), xr = rate(x.iface);
        if (cr && xr) {  // GigE family: the card / cable must carry the camera's speed
          if (x.g === "grabber") return xr >= cr ? [2, T("extras.fits_camera", "Fits your {iface} camera", { iface: s.iface })] : [0, T("extras.card_slow", "{card} card, camera is {iface}", { card: x.iface, iface: s.iface })];
          return cr > 1 && x.iface === "GigE" ? [1, T("extras.cat6a", "use a Cat6a cable for {iface}", { iface: s.iface })] : [2, T("extras.fits_camera", "Fits your {iface} camera", { iface: s.iface })];
        }
        var same = x.iface === s.iface || (x.iface === "Fiber" && /XoF|Fiber/.test(s.iface)) || (x.iface === "XoFLink" && /XoF/.test(s.iface));
        if (!same && /XoC/.test(s.iface) && x.iface === "CoaXPress") return [1, T("extras.xoc", "XoCLink camera: confirm with us")];
        return same ? [2, T("extras.fits_camera", "Fits your {iface} camera", { iface: s.iface })] : [0, T("extras.for_cameras", "For {iface} cameras", { iface: x.iface })];
      case "io":
        if (!s.io || !x.pins) return [1, T("extras.io_unstated", "camera I/O connector not stated")];
        return x.pins === s.io ? [2, T("extras.fits_pins", "Fits the {pins}-pin connector", { pins: s.io })] : [0, T("extras.pins_differ", "{pins}-pin, camera has {camera}-pin", { pins: x.pins, camera: s.io })];
      case "adapter":
        if (/C-mount lens on CS-mount camera/.test(x.use || "")) return needsRing(s) ? [2, T("extras.ring_needed", "Needed: C-mount lens on your CS-mount camera")] : [0, T("extras.ring_only", "Only for a C-mount lens on a CS-mount camera")];
        var cm = MOUNT[s.mount] || s.mount;
        if (cm && x.mounts && x.mounts.indexOf(cm) < 0) return [0, T("extras.for_mounts", "For {mounts} mounts", { mounts: x.mounts.join(" / ") })];
        return [2, cm && x.mounts ? T("extras.for_your_mount", "For your {mount} camera", { mount: s.mount }) : ""];
      case "light":
        if (!s.light) return [0, T("extras.no_light", "No light chosen")];
        if (s.light.conn && x.conn) return conn(x.conn) && conn(x.conn) === conn(s.light.conn) ? [2, T("extras.fits_conn", "Fits the {conn} connector", { conn: x.conn })] : [0, T("extras.conn_differs", "{conn} connector, light has {light}", { conn: x.conn, light: s.light.conn })];
        return [1, T("extras.conn_unstated", "light connector not stated")];
      default: return [2, ""];
    }
  }
  function relevant(g, s, picks) {
    if (g === "grabber") return /CoaXPress|Camera Link|XoF|XoC|Fiber/.test(s.iface || "") || (rate(s.iface) || 0) > 1;
    if (g === "gio") return picks.some(function (p) { return p.g === "grabber"; });
    if (g === "tele") return !!(s.lens && s.lens.k === "tele");
    if (g === "light") return !!s.light;
    if (g === "data" || g === "io") return !!(s.iface || s.camera);
    return true;
  }
  window.LSConfig.conn = conn;  // shared with the controller step's connector check
  LSConfig.step("extras", {
    fit: fit,
    skip: T("extras.skip", "Nothing else needed"),
    note: function (s) {
      return needsRing(s) ? T("extras.note_ring", "Your C-mount lens needs a 5 mm C-CS ring on the CS-mount camera: it is listed first.") : T("extras.note", "Add what the system needs; each group shows the parts that fit first.");
    },
    render: function render(el, api) {
      var s = api.sys, picked = {}, pickedRows = [];
      api.picks().forEach(function (p) { picked[p.h] = p; var r = api.row(p.h); if (r) pickedRows.push(r.x || {}); });
      var html = GROUPS.map(function (G) {
        var rows = api.rows.filter(function (r) { return r.x && r.x.g === G.g; }).map(function (r) { return [r, fit(r, s)]; })
          .filter(function (x) { return x[1][0] > 0 || picked[x[0].h]; });
        if (!rows.length || (!relevant(G.g, s, pickedRows) && !rows.some(function (x) { return picked[x[0].h]; }))) return "";
        rows.sort(function (a, b) { return (picked[b[0].h] ? 1 : 0) - (picked[a[0].h] ? 1 : 0) || b[1][0] - a[1][0]; });
        var n = open[G.g] ? rows.length : SHOW, why = G.why(s);
        return '<div class="cfggroup"><h3>' + api.esc(G.label) + (why ? " <small>" + api.esc(why) + "</small>" : "") + "</h3>" +
          '<div class="cfglist">' + rows.slice(0, n).map(function (x) { return api.card(x[0], x[1]); }).join("") + "</div>" +
          (rows.length > n ? '<button type="button" class="linkbtn" data-more="' + G.g + '">' + api.esc(T("extras.show_all", "Show all {n}", { n: rows.length })) + "</button>" : "") + "</div>";
      }).join("");
      el.innerHTML = html || '<p class="muted">' + api.esc(T("extras.empty", "Choose a camera or a light first and the matching cables show here.")) + "</p>";
      el.onclick = function (ev) {
        var t = ev.target.closest("button");
        if (!t) return;
        if (t.dataset.more) { open[t.dataset.more] = true; render(el, api); return; }
        var c = t.closest(".cfgcard");
        if (!c) return;
        if (t.classList.contains("cfgv")) {
          Array.prototype.forEach.call(c.querySelectorAll(".cfgv"), function (b) { b.classList.toggle("on", b === t); });
          var pk = picked[c.dataset.h];  // a variant change on a part already added updates that pick
          if (pk) api.pick(c.dataset.h, t.dataset.code, pk.n, pk.note);
        } else if (t.classList.contains("cfgpick")) {
          var on = c.querySelector(".cfgv.on");
          if (picked[c.dataset.h]) api.unpick(c.dataset.h); else api.pick(c.dataset.h, on ? on.dataset.code : "", 1);
          render(el, api);
        }
      };
    }
  });
})();

/* stand.js */
// Mounting step: build the stand from its options (stand.py reads them from the model codes and spec rows) and the
// step resolves the exact model. Heights tall enough for the lens step's working distance are marked.
(function () {
  var T = LSConfig.t, tr = LSConfig.tr;  // customer text (core.js); tr: display text of the English stand data (ui_map)
  var FAM = [];  // [key, title, one line, option labels], from the rows (stand.py): fixed families first, "other" last
  var ORDER = ["slide", "pole", "multi", "stage"];
  var HEIGHT = { "Column height": 1, "Pole height": 1, "Height": 1 };
  function families(rows) {
    var seen = {}, out = [];
    rows.forEach(function (r) {
      var x = r.x || {};
      if (!x.fam || seen[x.fam]) return;
      seen[x.fam] = 1;
      out.push([x.fam, x.ft || x.fam, x.fd || "", x.ol || []]);
    });
    var rank = function (f) { var i = ORDER.indexOf(f[0]); return f[0] === "other" ? 999 : i < 0 ? 100 : i; };
    return out.sort(function (a, b) { return rank(a) - rank(b) || a[1].localeCompare(b[1]); });
  }
  var CLEAR = 200;  // mm above the working distance for camera + lens + holder (rule of thumb, said on the page)
  var cur = null, sel = {};
  var num = function (v) { var m = String(v).match(/\d+(\.\d+)?/); return m ? parseFloat(m[0]) : 0; };

  function need(sys) { return sys.scene && sys.scene.wd_mm ? sys.scene.wd_mm + CLEAR : null; }
  function items(rows, fam) { return rows.filter(function (r) { return r.x && r.x.fam === fam; }); }
  function matches(r, s, skip) { return Object.keys(s).every(function (k) { return k === skip || !s[k] || r.x.o[k] === s[k]; }); }
  function values(list, label) {
    var v = {};
    list.forEach(function (r) { if (r.x.o[label]) v[r.x.o[label]] = 1; });
    return Object.keys(v).sort(function (a, b) { return num(a) - num(b) || a.localeCompare(b); });
  }

  function render(el, api) {
    var rows = api.rows, picked = api.picks()[0], sys = api.sys, h = need(sys);
    if (picked && !cur) {  // reopen on the family and options of the stand already chosen
      var pr = api.row(picked.h);
      if (pr && pr.x) { cur = pr.x.fam; sel[cur] = JSON.parse(JSON.stringify(pr.x.o || {})); }
    }
    if (!FAM.length) FAM = families(rows);
    var fams = FAM.filter(function (f) { return items(rows, f[0]).length; });
    if (!cur) cur = fams[0][0];
    var f = fams.filter(function (x) { return x[0] === cur; })[0] || fams[0], list = items(rows, f[0]), s = sel[f[0]] || (sel[f[0]] = {});
    var minP = function (l) { var p = l.map(function (r) { return r.p; }).filter(function (p) { return p != null; }); return p.length ? T("stand.from", "from {price}", { price: api.money(Math.min.apply(null, p)) }) : T("stand.on_request", "on request"); };
    var big = function (x) { return ORDER.indexOf(x[0]) >= 0 || x[0] === "other"; };
    var tabs = '<div class="stfams">' + fams.filter(big).map(function (x) {
      var l = items(rows, x[0]), img = (l[0] || {}).i;
      return '<button type="button" class="stfam' + (x[0] === f[0] ? " on" : "") + '" data-fam="' + x[0] + '">' + (img ? '<img src="' + api.esc(img) + '" alt="" loading="lazy">' : "") +
        "<b>" + api.esc(tr(x[1])) + "</b><span>" + api.esc(T("stand.models", "{n} models", { n: l.length })) + " · " + minP(l) + "</span></button>";
    }).join("") + "</div>";
    var more = fams.filter(function (x) { return !big(x); });
    if (more.length) tabs += '<details class="stmore"' + (big(f) ? "" : " open") + "><summary>" + api.esc(T("stand.more", "More stages, brackets and slides ({n} types)", { n: more.length })) + "</summary><div>" + more.map(function (x) {
      return '<button type="button" class="stpill' + (x[0] === f[0] ? " on" : "") + '" data-fam="' + x[0] + '">' + api.esc(tr(x[1])) + " <i>" + items(rows, x[0]).length + "</i></button>";
    }).join("") + "</div></details>";
    var body;
    if (!f[3].length) {
      body = '<p class="muted">' + api.esc(tr(f[2])) + '</p><div class="cfglist">' + list.map(function (r) { return api.card(r, [2, ""]); }).join("") + "</div>";
    } else {
      f[3].forEach(function (lab) {  // keep a choice only while some model has it with the other choices
        if (s[lab] && !list.some(function (r) { return matches(r, s, null); })) s[lab] = "";
      });
      var groups = f[3].map(function (lab) {
        var vals = values(list, lab);
        if (vals.length < 2) { if (vals.length === 1) s[lab] = vals[0]; return ""; }
        var rec = HEIGHT[lab] && h ? vals.filter(function (v) { return num(v) >= h; })[0] : null;
        return '<div class="stopt"><span>' + api.esc(tr(lab)) + "</span><div>" + vals.map(function (v) {
          var ok = list.some(function (r) { return r.x.o[lab] === v && matches(r, s, lab); });
          var low = HEIGHT[lab] && h && num(v) < h;
          return '<button type="button" class="stpill' + (s[lab] === v ? " on" : "") + (ok ? "" : " na") + (low ? " low" : "") + '" data-lab="' + api.esc(lab) + '" data-val="' + api.esc(v) + '"' +
            (low ? ' title="' + api.esc(T("stand.too_short", "Shorter than your working distance + {clear} mm for camera and lens", { clear: CLEAR })) + '"' : "") + ">" + api.esc(tr(v)) + (v === rec ? " <i>" + api.esc(T("stand.recommended", "recommended")) + "</i>" : "") + "</button>";
        }).join("") + "</div></div>";
      }).join("");
      var hit = list.filter(function (r) { return matches(r, s, null); });
      var open = f[3].filter(function (lab) { return !s[lab] && values(list, lab).length > 1; });
      body = '<p class="muted">' + api.esc(tr(f[2])) + (h ? " " + T("stand.height", "Your working distance needs about {height} of height ({wd} mm + {clear} mm for camera and lens).", { height: "<b>" + h + " mm</b>", wd: sys.scene.wd_mm, clear: CLEAR }) : "") + "</p>" +
        '<div class="stopts">' + groups + "</div>" +
        (open.length ? '<p class="cfgcount">' + T("stand.choose", "{n} models match · choose {options} for the exact model", { n: hit.length, options: open.map(function (o) { var d = tr(o); return d === o ? api.esc(o).toLowerCase() : api.esc(d); }).join(", ") }) + "</p>" : '<p class="cfgcount">' + api.esc(T("stand.your_config", "Your configuration:")) + "</p>") +
        '<div class="cfglist">' + hit.slice(0, open.length ? 6 : 1).map(function (r) {
          var spec = r.x.sp ? '<p class="stsp">' + api.esc(r.x.sp) + "</p>" : "";
          return api.card(r, [2, open.length ? "" : T("stand.exact", "Exact match")]).replace("</div><div class=\"cfgbuy\">", spec + "</div><div class=\"cfgbuy\">");
        }).join("") + "</div>";
    }
    el.innerHTML = tabs + body;
    el.onclick = function (ev) {
      var b = ev.target.closest("button");
      if (!b) return;
      if (b.dataset.fam) { cur = b.dataset.fam; render(el, api); return; }
      if (b.dataset.lab) {
        var lab = b.dataset.lab, v = b.dataset.val;
        s[lab] = s[lab] === v ? "" : v;
        f[3].forEach(function (o) {  // a value no model has with the others: keep it, drop the conflicting choices
          if (o !== lab && s[o] && !list.some(function (r) { return matches(r, s, null); })) s[o] = "";
        });
        render(el, api);
        return;
      }
      var c = b.closest(".cfgcard");
      if (c && b.classList.contains("cfgpick")) {
        var hh = c.dataset.h;
        if (api.picks().some(function (p) { return p.h === hh; })) { api.next(); return; }
        var r = api.row(hh), o = (r.x && r.x.o) || {};
        api.pick(hh, "", 1, Object.keys(o).map(function (k) { return o[k]; }).join(", "));
        render(el, api);
      }
    };
  }

  LSConfig.step("stand", {
    skip: T("stand.skip", "No stand needed"),
    fit: function () { return [2, ""]; },
    note: function (sys) {
      return (sys.lens ? T("stand.note_lens", "Build the stand that holds your camera and lens: pick the options and we show the exact model.")
        : T("stand.note", "Build the stand that holds your camera: pick the options and we show the exact model.")) +
        (need(sys) ? "" : " " + T("stand.note_wd", "Enter a working distance in the lens step and we mark the heights that fit."));
    },
    render: render,
    apply: function (r, p, sys) { sys.stand = r.m; }
  });
})();

LSConfig.start();
